module.exports = __webpack_public_path__ + "static/media/bg_3.e292fa66.jpg";